<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/system' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>赛事视频管理</el-breadcrumb-item>
      <el-breadcrumb-item>设置培训视频</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片 -->
    <el-card class="box-card">
      <el-row :gutter="20">
        <el-col :span="4" style="width:360px !important;margin-right: 20px;">
          <el-select
            v-model="queryInfo.MatchID"
            placeholder="请选择赛项名称"
            clearable
            @clear="getVideoList(1)"
            style="width:360px !important;"
          >
            <el-option
              v-for="item in matchNameoptions"
              :key="item.MatchID"
              :label="item.MatchName"
              :value="item.MatchID"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="2">
          <el-button
            icon="el-icon-search"
            type="primary"
            @click="getVideoList(1)"
            >搜索</el-button
          >
        </el-col>
        <el-col :span="6">
          <el-button type="primary" @click="showEditCreate('add')"
            >添加视频</el-button
          >
        </el-col>
      </el-row>

      <!-- 表格列表 -->
      <el-table :data="pagedata" style="width: 100%" border stripe size="mini">
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column prop="MatchName" label="赛事名称" width="280">
        </el-table-column>
        <el-table-column prop="VideoName" label="视频名称"> </el-table-column>
        <el-table-column
          prop="VideoIntro"
          label="视频介绍"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column prop="FileSize" label="文件大小">
          <template slot-scope="scope">
            <div>{{ parseInt(scope.row.FileSize) }} KB</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="AddTime"
          label="添加日期"
          :formatter="dataFormat"
        >
        </el-table-column>
        <el-table-column label="操作" width="280">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-edit"
              size="mini"
              @click="showEditCreate('edit', scope.row)"
              >修改</el-button
            >
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="deleteCreate(scope.row.TrainingVideoID)"
              >删除</el-button
            >
            <el-button
              type="warning"
              icon="el-icon-view"
              size="mini"
              @click="showVideo(scope.row)"
              >视频管理</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[1, 2, 5, 10]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      >
      </el-pagination>
      <!-- 修改 -->
      <el-dialog
        :title="dialogTitle"
        :visible.sync="editDialogVisible"
        width="30%"
        @close="editresetFields"
      >
        <el-form
          :model="editForm"
          :rules="editRules"
          ref="editFormRef"
          label-width="100px"
        >
          <el-form-item label="赛事名称" prop="MatchID">
            <el-select v-model="editForm.MatchID" placeholder="请选择" style="width: 370px !important">
              <el-option
                v-for="item in matchNameoptions"
                :key="item.MatchID"
                :label="item.MatchName"
                :value="item.MatchID"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="视频名称" prop="VideoName">
            <el-input v-model="editForm.VideoName"></el-input>
          </el-form-item>

          <el-form-item label="视频介绍" prop="VideoIntro">
            <el-input type="textarea" v-model="editForm.VideoIntro"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="editCreate()" :loading="loading"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <!-- 预览 -->
      <el-dialog title="预览视频" :visible.sync="showDialogVisible" width="30%">
        <el-upload
          class="avatar-uploader"
          ref="upload"
          :action="urlApi"
          :headers="headers"
          :limit="1"
          :on-exceed="handleExceed"
          :data="videodata"
          v-bind:on-progress="uploadVideoProcess"
          v-bind:on-success="handleVideoSuccess"
          v-bind:before-upload="beforeUploadVideo"
          v-bind:show-file-list="false"
          v-model="VideoFile"
        >
          <el-button type="primary" size="mini">
            <i class="el-icon-plus avatar-uploader-icon"></i> 上传视频
          </el-button>

          <div slot="tip" class="el-upload__tip">
            建议大小100M以下，格式mp4
          </div>
        </el-upload>
        <el-progress
          v-if="videoFlag === true"
          :percentage="videoUploadPercent"
        ></el-progress>
        <p v-show="VideoFile === '' ? false : true">
          {{ fileName }}
          <i class="el-icon-delete delicon" @click="deletevideo()"></i>
        </p>
        <video
          :src="VideoFile"
          width="100%"
          controls="controls"
          v-show="VideoFile === '' ? false : true"
          class="videomain"
        >
          your browser does not support the video tag
        </video>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 获取列表
      queryInfo: {
        // 查询参数
        MatchName: '',
        // 当前页码
        pagenum: 1,
        // 每页显示条数
        pagesize: 10
      },
      pagedata: [],
      total: 0,
      // 添加弹框显示状态
      addDialogVisible: false,
      // 修改弹框显示状态
      editDialogVisible: false,
      // 预览
      showDialogVisible: false,
      // 弹窗默认标题
      dialogTitle: '',
      // 添加表单
      editForm: {
        MatchID: '',
        VideoName: '',
        VideoIntro: ''
      },
      // 视频链接
      VideoFile: '',
      // 视频上传接口地址
      urlApi:
        process.env.VUE_APP_BASE_URL +
        '/api/TrainingVideoFile/EditTrainingVideoFile',
      headers: { Authorization: 'Bearer ' },
      // 修改表单验证
      editRules: {
        MatchID: [
          {
            required: true,
            message: '请选择赛事名称',
            trigger: 'change'
          }
        ],
        VideoName: [
          {
            required: true,
            message: '请输入视频名称',
            trigger: 'blur'
          }
        ],
        VideoIntro: [
          {
            required: true,
            message: '请输入视频介绍',
            trigger: 'blur'
          }
        ],
        VideoFile: [
          {
            required: true,
            message: '请上传视频',
            trigger: 'change'
          }
        ]
      },
      // 赛事名称下拉选项
      matchNameoptions: [
        {
          value: '1',
          label: '赛事1'
        },
        {
          value: '2',
          label: '赛事2'
        }
      ],
      // 加载中状态
      loading: false,
      fileList: [],
      domin: '',
      fulldomin: '',
      videoFlag: false,
      // 否显示进度条
      videoUploadPercent: '',
      // 进度条的进度，
      // isShowUploadVideo: false,
      videodata: {
        TrainingVideoID: '',
        MatchID: ''
      },
      fileName: ''
    }
  },
  created() {
    //   默认获取列表
    this.getVideoList(1)
    // 默认获取赛事
    this.getAllMatch()
    this.getToken()
  },
  methods: {
    //   获取列表
    async getVideoList(newPage) {
      this.queryInfo.pagenum = newPage
      const { data: res } = await this.$http.get(
        '/api/TrainingVideo/GetAllVideoes',
        { params: this.queryInfo }
      )
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.pagedata = res.Data.trainingVideos
      this.total = res.Data.total
    },
    //   下拉获取所有赛事
    async getAllMatch() {
      const { data: res } = await this.$http.get('/api/Match/GetMatchs')
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.matchNameoptions = res.Data.matchs
      this.matchNameoptions2 = res.Data.matchs
    },
    // 监听pagesize 切换显示多少条 事件
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize
      this.getVideoList(1)
    },
    // 监听点击了第几页 事件
    handleCurrentChange(newPage) {
      this.queryInfo.pagenum = newPage
      this.getVideoList(newPage)
    },
    // 关闭弹窗重置表单验证
    addresetFields() {
      this.$refs.addFormRef.resetFields()
    },
    // 关闭弹窗重置表单验证
    editresetFields() {
      this.editForm = {
        MatchID: '',
        VideoName: '',
        VideoIntro: ''
      }
      this.$refs.editFormRef.resetFields()
    },
    // 显示添加修改弹窗
    showEditCreate(type, row) {
      if (type === 'add') {
        this.dialogTitle = '添加视频'
      } else if (type === 'edit') {
        this.$nextTick(() => {
          // 注意看这里
          this.dialogTitle = '修改视频'
          // 回填表单
          this.editForm = JSON.parse(JSON.stringify(row))
        })
      }
      this.editDialogVisible = true
    },
    // 预览视频
    showVideo(row) {
      this.showDialogVisible = true
      // console.log(row)
      this.videodata.TrainingVideoID = row.TrainingVideoID
      this.videodata.MatchID = row.MatchID
      console.log(this.videodata)
      this.VideoFile =
        row.FileName === null ? '' : process.env.VUE_APP_BASE_URL + row.FileName
      this.fileName = row.OldFileName
    },
    // 修改
    editCreate() {
      this.$refs.editFormRef.validate(async (valid) => {
        // 验证不通过跳出
        if (!valid) return false
        // 发起添加请求
        const { data: res } = await this.$http.post(
          '/api/TrainingVideo/EditTrainingVideo',
          this.editForm
        )
        // 判断状态码
        if (res.StatusCode !== 1) return this.$message.error(res.Msg)
        // 成功提示
        this.$message.success(res.Msg)
        // 关闭弹窗
        this.editDialogVisible = false
        this.getVideoList(this.queryInfo.pagenum)
      })
    },
    // 删除
    async deleteCreate(id) {
      // 提示是否确认删除
      const res = await this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch((err) => {
        return err
      })
      if (res !== 'confirm') return this.$message.info('已取消删除')
      const { data: resdel } = await this.$http.post(
        '/api/TrainingVideo/DeleteTrainingVideo?trainingVideoID=' + id
      )
      if (resdel.StatusCode !== 1) return this.$message.error('删除失败')
      this.$message.success('删除成功')
      // 刷新列表
      this.getVideoList(this.queryInfo.pagenum)
    },
    // 删除视频文件
    async deletevideo() {
      // 提示是否确认删除
      const res = await this.$confirm('确认删除视频文件吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch((err) => {
        return err
      })
      if (res !== 'confirm') return this.$message.info('已取消删除')
      const { data: resdel } = await this.$http.post(
        '/api/TrainingVideoFile/DeleteTrainingVideoFile?TrainingVideoID=' +
          this.videodata.TrainingVideoID
      )
      if (resdel.StatusCode !== 1) return this.$message.error('删除失败')
      this.$message.success('删除成功')
      this.showDialogVisible = false
      // 刷新列表
      this.getVideoList(this.queryInfo.pagenum)
    },
    // 上传前回调
    beforeUploadVideo(file) {
      var fileSize = file.size / 1024 / 1024 < 100
      if (
        [
          'video/mp4'
          // 'video/ogg',
          // 'video/flv',
          // 'video/avi',
          // 'video/wmv',
          // 'video/rmvb',
          // 'video/mov'
        ].indexOf(file.type) === -1
      ) {
        this.$message.error('请上传mp4格式的视频')
        this.fileList = []
        return false
      }
      if (!fileSize) {
        this.$message.error('视频大小不能超过100MB')
        this.fileList = []
        return false
      }
      // this.isShowUploadVideo = false
    },
    // 进度条
    uploadVideoProcess(event, file, fileList) {
      this.videoFlag = true
      this.videoUploadPercent = file.percentage.toFixed(0) * 1
    },
    handleExceed(files, fileList) {
      this.$message.warning('最多可以上传1个视频')
    },
    // 上传成功回调
    handleVideoSuccess(res, file) {
      console.log(res)
      // 后台上传地址
      if (res.StatusCode === 1) {
        // 关闭弹窗
        this.showDialogVisible = false
        this.videoFlag = false
        this.VideoFile =
          process.env.VUE_APP_BASE_URL +
          res.Data.trainingVideoFileCurrent.FileName
        this.$message.success(res.Msg)
        this.clearfile()
        // 刷新列表
        this.getVideoList(this.queryInfo.pagenum)
      } else {
        this.$message.error(res.Msg)
      }
    },
    clearfile() {
      // 清空文件列表
      this.$refs.upload.clearFiles()
    },
    getToken() {
      this.headers.Authorization = window.localStorage.getItem('token')
    },
    // 时间格式化
    dataFormat: function (row, column) {
      var date = row[column.property]
      if (date === undefined) {
        return ''
      }
      return this.$moment(date).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
<style lang="less">
.el-upload__tip {
  margin-bottom: 20px;
}
.videomain {
  margin-top: 20px;
}
.delicon {
  cursor: pointer;
  color: red;
  font-size: 20px;
}
.el-tooltip__popper {
  font-size: 14px;
  max-width: 50%;
}
</style>
